module.exports = __webpack_public_path__ + "img/logo_bras.3e813c6d.png";